export const SEAT_LIMITS_TOOLTIP = "Limit reached. Upgrade plan to get more seats.";
